export default __webpack_public_path__ + "static/media/view4_month_province__.baebc3bd.csv";